// extracted by mini-css-extract-plugin
export default {"Title":"Step2Chat_Title__fqw0l","TextContainer":"Step2Chat_TextContainer__vWMXB"};